export default __webpack_public_path__ + "static/media/login-wave.3b63148b.svg";